<div c-toggle="workflowsVisible" c-toggle-options="{type: 'fade'}">
    <search-view query="query"  highlight="highlight" filter-config="filterConfig" search-url="searchUrl"></search-view>
</div>